<template>
<div class="columns referral-input-box-root">
  <div class="column">
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Your Referral Link</label>
      </div>
      <div class="field-body" style="flex-grow: 3">
        <div class="field has-addons">
          <div class="control is-expanded">
            <input class="browser-default input" type="text" readonly :value="referralLink" ref="input">
          </div>
          <div class="control">
            <a class="button primary" @click="copyReferralLink">Copy</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { toast } from '@/js/utils.js'

export default {
  name: 'referral-input-box',
  props: ['referralId'],
  computed: {
    referralLink () {
      const { referralId } = this
      return `https://twoseven.xyz/?referral=${referralId}`
    }
  },
  methods: {
    toast,
    async copyReferralLink () {
      try {
        const { referralLink } = this
        await this.$copyText(referralLink)
        toast('Copied')
      } catch (e) {
        toast('Failed to copy referral link. Please report this')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.referral-input-box-root {
  input {
    border-color: var(--primary-color-lighten-5) !important;
    &:focus {
      outline: none;
      border-color: inherit;
    }
  }
  a.button.primary {
    border-color: var(--primary-color) !important;
  }
}
</style>
